import { Config } from "@7egend/dxp-web-core"
import { useFramework } from "@7egend/web-core/lib/components/useFramework"

export const useConfig = () => {
	const { config } = useFramework()

	return config as Config
}

export const useConfigFootlabModule = () => {
	const config = useConfig()

	return config.modules.find((m) => m.key === "footlab") as Config["modules"][0]
}
